import { render, staticRenderFns } from "./OnlineOrderModifierGroup.vue?vue&type=template&id=1afa9382&"
import script from "./OnlineOrderModifierGroup.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderModifierGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports